import moment from 'moment'

export const getVisitStudyDayNumber = visit => {
  if (!visit) return null
  const visitStudyDayRaw =
    visit.metadata?.computed_study_day !== undefined
      ? visit.metadata.computed_study_day
      : visit.day !== undefined && visit.day !== null
        ? visit.day
        : null

  if (visitStudyDayRaw === null || visitStudyDayRaw === undefined) return null

  let visitStudyDayNum = Number(visitStudyDayRaw)
  if (!Number.isFinite(visitStudyDayNum) || visitStudyDayNum < 1) {
    visitStudyDayNum = 1
  }
  return visitStudyDayNum
}

const participantVisitStudyDay = (visitId, participantVisits, point, context) => {
  const row = participantVisits.find(v => v?.visit_id != null && String(v.visit_id) === String(visitId))
  if (!row) return null

  const useAbsoluteStartDate = context.useAbsoluteStartDate
  const absoluteStartDate = context.absoluteStartDate
  if (!useAbsoluteStartDate || !absoluteStartDate) {
    return getVisitStudyDayNumber({ id: visitId, day: row.study_day, metadata: row.metadata })
  }

  const dateField =
    point === 'completed' || point === 'completion'
      ? row.completed_date || row.completion_date
      : point === 'missed'
        ? row.missed_date
        : point === 'appointment_scheduled'
          ? row.appointment_scheduled_date || row.scheduled_date
          : row.target_date || row.visit_date || row.date

  if (!dateField) return null
  const visitMoment = moment.utc(dateField).startOf('day')
  const startMoment = moment.utc(absoluteStartDate).startOf('day')
  if (!visitMoment.isValid() || !startMoment.isValid()) return null
  return Math.max(1, visitMoment.diff(startMoment, 'days') + 1)
}

export const resolveVisitAnchorStudyDay = (anchor, visits, selectedArmVisitIds, context = {}) => {
  const refs = Array.isArray(anchor.visits) ? anchor.visits : []
  const visitIds = refs
    .map(v => v?.visit_id ?? v?.id)
    .filter(id => id != null && id !== '')
  if (!visitIds.length && anchor.visit_id != null) visitIds.push(anchor.visit_id)

  const candidateIds =
    selectedArmVisitIds != null
      ? visitIds.filter(id => selectedArmVisitIds.has(String(id)))
      : visitIds
  const idsToTry = candidateIds.length ? candidateIds : visitIds
  if (selectedArmVisitIds != null && candidateIds.length === 0) return null

  const point = anchor.point || 'target'
  const participantVisits = context.participantVisits
  const useParticipant =
    context.projectionMode === 'participant' && Array.isArray(participantVisits) && participantVisits.length

  for (const visitId of idsToTry) {
    if (useParticipant) {
      const day = participantVisitStudyDay(visitId, participantVisits, point, context)
      if (day != null) return day
    }
    const visit = visits.find(v => v?.id != null && String(v.id) === String(visitId))
    const day = getVisitStudyDayNumber(visit)
    if (day != null) return day
  }
  return null
}

/** Used by legacy visit chain when participant mode is on. */
export const getVisitStudyDayFromTemplate = (
  anchor,
  templateVisits,
  selectedArmVisitIds = null,
  participantVisits = null,
  context = {},
) =>
  resolveVisitAnchorStudyDay(
    {
      ...anchor,
      point: anchor.point || 'target',
    },
    templateVisits,
    selectedArmVisitIds,
    {
      ...context,
      participantVisits,
    },
  )
